<template>
    <div
      class="rn-service-area service-area rn-section-gap" id="service"
       v-if="NOTARIA && NOTARIA.Theme && NOTARIA.Theme.Home.Servicios.Mostrar"
    >
        <v-container>
            <v-row>
                <v-col sm="12" cols="12">
                  <div class="section-title-notin mb--30 banner-home-servicios-notin">
                    <NuxtLink :to="getLocalePath('/servicios')">
                      <h2 class="heading-title">
                        {{NOTARIA.Theme.Home.Servicios.Titulo.Texto}}
                      </h2>
                    </NuxtLink>
                    <p >
                        {{NOTARIA.Theme.Home.Servicios.Descripcion.Texto}}
                      </p>
                  </div>
                </v-col>
            </v-row>
            <ServiceNotinList :object="NOTARIA.Theme.Home.Servicios.Tarjeta" :Home="true" type="home-servicios"/>
            
            <v-row v-if="NOTARIA.Theme.Home.Servicios.ShowButton" class="mt--40">
                <v-col cols="12" class="text-center">
                    <v-btn
                        class="rn-btn"
                        :style="buttonStyle"
                        @click="navigateTo(getLocalePath('/servicios'))"
                    >
                        {{ NOTARIA.Theme.Home.Servicios.Button.Texto }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import {useStore} from '../../store/index'
const store = useStore()
const {NOTARIA} = storeToRefs(store)
import { useUtils } from '#imports';
const {imagenIDtoSRC,$t,getLocalePath}=useUtils()
import { useStyles } from '../../store/styles';
const style = useStyles();


const estiloTituloColor = computed(() => style.ThemeHomeService?.Titulo?.css?.Color)
const estiloTituloBackgroundColor = computed(() => style.ThemeHomeService?.Titulo?.css?.BackgroundColor)
const estiloTituloShadow = computed(() => {
    const bg = style.ThemeHomeService?.Titulo?.css?.BackgroundColor;
    return (bg && bg !== 'transparent' && bg !== '#00000000' && bg !== '#0000') ? "4px 2px 6px " + bg : "none";
})
const estiloTituloFont = computed(() => style.ThemeHomeService?.Titulo?.css?.Font)
const estiloTituloSize = computed(() => style.ThemeHomeService?.Titulo?.css?.Size)
const estiloTituloWeight = computed(() => style.ThemeHomeService?.Titulo?.css?.Weight)
const estiloTituloAlign = computed(() => style.ThemeHomeService?.Titulo?.css?.Align)

const estiloDescripcionColor = computed(() => style.ThemeHomeService?.Descripcion?.css?.Color)
const estiloDescripcionBackgroundColor = computed(() => style.ThemeHomeService?.Descripcion?.css?.BackgroundColor)
const estiloDescripcionShadow = computed(() => {
    const bg = style.ThemeHomeService?.Descripcion?.css?.BackgroundColor;
    return (bg && bg !== 'transparent' && bg !== '#00000000' && bg !== '#0000') ? "4px 2px 6px " + bg : "none";
})
const estiloDescripcionFont = computed(() => style.ThemeHomeService?.Descripcion?.css?.Font)
const estiloDescripcionSize = computed(() => style.ThemeHomeService?.Descripcion?.css?.Size)
const estiloDescripcionWeight = computed(() => style.ThemeHomeService?.Descripcion?.css?.Weight)
const estiloDescripcionAlign = computed(() => style.ThemeHomeService?.Descripcion?.css?.Align)

const estiloTarjetaTituloColor = computed(() => style.ThemeHomeService?.Tarjeta?.Titulo?.css?.Color)
const estiloTarjetaTituloBackgroundColor = computed(() => style.ThemeHomeService?.Tarjeta?.Titulo?.css?.BackgroundColor)
const estiloTarjetaTituloShadow = computed(() => {
    const bg = style.ThemeHomeService?.Tarjeta?.Titulo?.css?.BackgroundColor;
    return (bg && bg !== 'transparent' && bg !== '#00000000' && bg !== '#0000') ? "4px 2px 6px " + bg : "none";
})
const estiloTarjetaTituloFont = computed(() => style.ThemeHomeService?.Tarjeta?.Titulo?.css?.Font)
const estiloTarjetaTituloSize = computed(() => style.ThemeHomeService?.Tarjeta?.Titulo?.css?.Size)
const estiloTarjetaTituloWeight = computed(() => style.ThemeHomeService?.Tarjeta?.Titulo?.css?.Weight)
const estiloTarjetaTituloAlign = computed(() => style.ThemeHomeService?.Tarjeta?.Titulo?.css?.Align)

const estiloTarjetaDescripcionColor = computed(() => style.ThemeHomeService?.Tarjeta?.Descripcion?.css?.Color)
const estiloTarjetaDescripcionBackgroundColor = computed(() => style.ThemeHomeService?.Tarjeta?.Descripcion?.css?.BackgroundColor)
const estiloTarjetaDescripcionShadow = computed(() => {
    const bg = style.ThemeHomeService?.Tarjeta?.Descripcion?.css?.BackgroundColor;
    return (bg && bg !== 'transparent' && bg !== '#00000000' && bg !== '#0000') ? "4px 2px 6px " + bg : "none";
})
const estiloTarjetaDescripcionFont = computed(() => style.ThemeHomeService?.Tarjeta?.Descripcion?.css?.Font)
const estiloTarjetaDescripcionSize = computed(() => style.ThemeHomeService?.Tarjeta?.Descripcion?.css?.Size)
const estiloTarjetaDescripcionWeight = computed(() => style.ThemeHomeService?.Tarjeta?.Descripcion?.css?.Weight)
const estiloTarjetaDescripcionAlign = computed(() => style.ThemeHomeService?.Tarjeta?.Descripcion?.css?.Align)

const estiloTarjetaDescripcionBackground = computed(() => {
  const fondo = style.ThemeHomeService?.Tarjeta?.FondoCSS;
  if(fondo?.BackgroundColorGradient){
    return "linear-gradient(to right," + (fondo.BackgroundColor || 'transparent') + "," + fondo.BackgroundColorGradient + ")"
  }else{
    return fondo?.BackgroundColor || 'transparent'
  }
})

const buttonStyle = computed(() => ({
    color: style.ThemeHomeService?.Button?.css?.Color || '',
    fontFamily: style.ThemeHomeService?.Button?.css?.Font || '',
    fontSize: style.ThemeHomeService?.Button?.css?.Size || '',
    fontWeight: style.ThemeHomeService?.Button?.css?.Weight || '',
    backgroundColor: style.ThemeHomeService?.Button?.css?.BackgroundColor || '',
    borderColor: style.ThemeHomeService?.Button?.css?.BackgroundColor || '',
    textTransform: 'none !important'
}))

</script>
<style lang="scss">

.banner-home-servicios-notin h2{
            color:v-bind(estiloTituloColor)  !important;
            text-shadow:v-bind(estiloTituloShadow)  !important;
            font-family:v-bind(estiloTituloFont)  !important;
            font-size:v-bind(estiloTituloSize) !important;
            font-weight:v-bind(estiloTituloWeight) !important;
            text-align:v-bind(estiloTituloAlign)  !important;
            }

            .banner-home-servicios-notin p{
            color:v-bind(estiloDescripcionColor) !important;
            text-shadow:v-bind(estiloDescripcionShadow)  !important;
            font-family:v-bind(estiloDescripcionFont)  !important;
            font-size:v-bind(estiloDescripcionSize)  !important;
            font-weight:v-bind(estiloDescripcionWeight)  !important;
            text-align:v-bind(estiloDescripcionAlign)  !important;
            }

            .card-home-servicios-notin h3, .card-home-servicios-notin h5{
            color:v-bind(estiloTarjetaTituloColor) !important;
            text-shadow:v-bind(estiloTarjetaTituloShadow) !important;
            font-family:v-bind(estiloTarjetaTituloFont) !important;
            font-size:v-bind(estiloTarjetaTituloSize) !important;
            font-weight:v-bind(estiloTarjetaTituloWeight) !important;
            text-align:v-bind(estiloTarjetaTituloAlign) !important;
            width: 100% !important;
            }

            .card-home-servicios-notin p{
            color:v-bind(estiloTarjetaDescripcionColor) !important;
            text-shadow:v-bind(estiloTarjetaDescripcionShadow) !important;
            text-align: v-bind(estiloTarjetaDescripcionAlign) !important;
            font-size:v-bind(estiloTarjetaDescripcionSize) !important;
            font-family:v-bind(estiloTarjetaDescripcionFont) !important;
            font-weight:v-bind(estiloTarjetaDescripcionWeight)!important;
            width: 100% !important;
            }

          .card-home-servicios-notin a, .card-home-servicios-notin .service, .card-home-servicios-notin .content{
            width: 100% !important;
            display: block !important;
          }
          .card-home-servicios-notin a:before{
            background:v-bind(estiloTarjetaDescripcionBackground);
          }

</style>